import { IProjects } from '@modules/accounting-and-finance/interface/projects/projects.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IProjects[] = [];

export const ACCGProjectsSlice = createSlice({
  name: 'accgProject',
  initialState,
  reducers: {
    setACCGProjects: (_state, action: PayloadAction<IProjects[]>) => {
      return [...action.payload];
    },
    removeACCGProjects: () => {
      return initialState;
    },
  },
});

export default ACCGProjectsSlice.reducer;

export const { setACCGProjects, removeACCGProjects } =
  ACCGProjectsSlice.actions;
